import { useContext, useEffect, useState } from "react";
import PopupContent from "../components/popupContent";

import PopupOperationsBar from "./PopupOperationsBar";
import iconBaze from "../images/buttons/baze.png";
import { apiUploadFile } from "../services/FilesService";
import { useTranslation } from "react-i18next";
import TranslationContext from "../providers/TranslationContext";
require("./PopupGeneralStyles.css");

interface Props {
    onCancel: any;
    onSuccess: any;
    onError?: any;
    id: any;
}

const FileUploadPopup = (props: Props) => {
    const translationContext = useContext(TranslationContext) as any;
    const prefix = translationContext.prefix;
    const { t } = useTranslation(undefined, { keyPrefix: `${prefix}.Popup` });

    const [file, setFile] = useState<Blob>();
    const [fileName, setFileName] = useState<string>();
    const [image, setImage] = useState<string>();

    useEffect(() => {

    }, []);

    const onCancelClick = () => {
        props.onCancel();
    };

    const handleChange = (e: any) => {
        console.log(e.target.files[0]);
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);

        setImage(URL.createObjectURL(e.target.files[0]));
    };

    const handleUploadFile = () => {
        if (file && fileName) {
            const formData = new FormData();
            formData.append('formFile', file);
            formData.append('fileName', fileName);
            try {
                apiUploadFile(formData)
                    .then((responseData: any) => {
                        console.log(responseData);
                        props.onSuccess(fileName);
                    });
            }
            catch (ex: any) {
                console.log(ex);
                props.onError(ex);
            }
        }
    };

    return (
        <PopupContent
            headerIcon={iconBaze}
            header={t('UploadHeader')}>
            <>
                <div>
                    <input type="file" name="file" onChange={handleChange} />
                </div>

                {image && <img style={{ width: 50, height: 50 }} src={image} />}

                <PopupOperationsBar
                    handleAdding={handleUploadFile}
                    handleCancellation={onCancelClick}
                    addingText={t('UploadButton')}
                />
            </>
        </PopupContent>
    );
};

export default FileUploadPopup;

